module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/97/assets/images/8e8d4feac8f8d40612e2bc3629a14a3b.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Epic/Epic1.svg
// module id = W7lP
// module chunks = 1